/**
 * Avatar upload and preview functionality
 */

export default (() => {
  // Get all elements with the "avatar-upload" class
  const avatarInputs = document.querySelectorAll('.avatar-upload')

  // Loop through each avatar input element
  avatarInputs.forEach((avatarInput, index) => {
    const avatarPreview = document.querySelectorAll('.avatar-preview')[index]
    const avatarIcon = document.querySelectorAll('.avatar-icon')[index]

    // Add an event listener to each avatar input element
    avatarInput.addEventListener('change', function () {
      if (avatarInput.files && avatarInput.files[0]) {
        const reader = new FileReader()

        reader.onload = function (e) {
          // Update the corresponding preview and hide the icon
          avatarPreview.src = e.target.result
          avatarPreview.style.display = 'block'
          avatarIcon.setAttribute('style', 'display:none !important')
        }

        reader.readAsDataURL(avatarInput.files[0])
      }
    })
  })
})()
